/**
 * Created by akrio on 2018/3/23.
 */
import {
  MEDIA_LIBRARY_LIST,
  MEDIA_LIBRARY_PARAMS,
  SAVED_LIBRARY_LIST,
  SAVED_LIBRARY_PARAMS,
} from "../mutation-types";

export default {
  state: {
    params: null,
    mediaLibraryList: null, // media library 列表
    savedParams: null, // saved library 查询参数
    savedLibraryList: null, // saved library 数据列表
  },
  mutations: {
    [MEDIA_LIBRARY_LIST](state, list) {
      state.mediaLibraryList = list;
      if (!list.count) {
        list.count = 0;
      }
      state.mediaLibraryList.count = Number(list.count);
    },
    [MEDIA_LIBRARY_PARAMS](state, params) {
      state.params = params;
    },
    [SAVED_LIBRARY_LIST](state, list) {
      state.savedLibraryList = list;
      state.savedLibraryList.count = Number(list.count);
    },
    [SAVED_LIBRARY_PARAMS](state, params) {
      state.savedParams = params;
    },
  },
  getters: {
    [MEDIA_LIBRARY_PARAMS](state) {
      return state.params;
    },
    [MEDIA_LIBRARY_LIST](state) {
      if (state.mediaLibraryList) {
        return state.mediaLibraryList;
      }
      return {
        count: 0,
        list: [],
      };
    },
    [SAVED_LIBRARY_LIST](state) {
      if (state.savedLibraryList) {
        return state.savedLibraryList;
      }
      return {
        count: 0,
        list: [],
      };
    },
    [SAVED_LIBRARY_PARAMS](state) {
      return state.savedParams;
    },
  },
};
